<!--
 * @description: 设备维护
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="Equipmentsindex"
      :condition="conditionData"
      editType="false"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
      @getReqData="getListData"
    >
      <template v-slot:tabelTitleLeft>
        <div>设备管理信息列表</div>
        <div style="margin-left: 20px">总计：{{ rowsCount }}</div>
      </template>

      <template v-slot:tabelTitleRight>
        <update-button @buttonClick="addPower"> 添加 </update-button>
        <update-button @buttonClick="exportFn"> 导出 </update-button>
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguBrand"
          class="condition-container-input"
        ></text-field>

        <text-field
          v-model:value="conditionData.ProductId"
          labelText="产品类别:"
          ref="selectChild"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildData"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.ModelId"
          labelText="产品型号:"
          ref="selectChildMoid"
          :clearable="true"
          :type="selectChildMoid == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildMoid"
          :selectRemoteSearchData="selectOuguNameModelSelect"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.SN"
          labelText="SN号:"
          class="condition-container-input"
        ></text-field>
      </template>

      <template v-slot:repairBtn="$opData">
        <div class="opration">
          <control-button
            class="item"
            @buttonClick="handOpenImg($opData.data.row)"
            >图</control-button
          >
        </div>
      </template>

      <template v-slot:oprator="$opData">
        <div class="style-aaa" @click="delSingleUser($opData.data)">删除</div>
        <div class="opration">
          <!-- <del-border
            class="item"
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="delSingleUser($opData.data)"
          ></del-border> -->
        </div>
      </template>
    </tabel-panel>

    <pop-dialog
      id="loadBOX"
      @confirmClick="listDataSave"
      v-if="loadShow"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      @dialogClose="loadShow = false"
    >
      <template v-slot="idData">
        <div class="saveBox">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span class="colorRed">*</span>
                品牌名称:
                <el-select
                  v-model="popSaveData.BrandId"
                  clearable
                  placeholder="请选择"
                  @change="addProductSelect"
                  required
                  size="small"
                >
                  <el-option
                    v-for="item in BrandData"
                    :key="item.id"
                    :label="item.Name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span class="colorRed">*</span>
                产品类别:
                <el-select
                  v-model="popSaveData.ProductId"
                  clearable
                  size="small"
                  placeholder="请选择"
                  @change="addModelSelect"
                >
                  <el-option
                    v-for="item in ProductData"
                    :key="item.id"
                    :label="item.Name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span class="colorRed">*</span>
                产品型号:
                <el-select
                  v-model="popSaveData.ModelNoid"
                  clearable
                  size="small"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in modelData"
                    :key="item.id"
                    :label="item.Name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span class="colorRed">*</span>
                SN号:
                <el-input
                  size="small"
                  v-model="popSaveData.SerialNoName"
                  placeholder="请输入SN号"
                  required
                  @change="SNSearch"
                  class="inputSN"
                ></el-input>
              </div>
            </el-col>
          </el-row>
          <div>
            <span>附件:</span>
            <el-checkbox-group v-model="checkedList">
              <el-checkbox
                v-for="city in AttachData"
                :label="city.id"
                :key="city.id"
                @change="handleCheckedCitiesChange(city)"
                :value="city.Name"
              >
                {{ city.Name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- <div>
					<span class="colorRed">*</span>
					症状:
					<el-select size="small"
						v-model="popSaveData.ModelIllId"
						clearable
						placeholder="请选择"
						@change="addModelIllID"
					>
						<el-option
							v-for="item in ModelIllData"
							:key="item.id"
							:label="item.Name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</div> -->

          <!-- <div>
					<span>症状信息:</span>
					<el-input size="small"
						v-model="popSaveData.CusApp"
						placeholder=""
						@change="zxc"
					></el-input>
				</div> -->

          <div>
            <span>备注:</span>
            <el-input
              size="small"
              v-model="popSaveData.IllDesc"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            >
            </el-input>
          </div>
        </div>
      </template>
    </pop-dialog>
    <el-dialog
      v-model="centerDialogVisible"
      width="25%"
      :show-close="false"
      center
    >
      <div>
        <img style="width: 100%" :src="openImg" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
import textField from "@/components/textField.vue";
import delBorder from "@/components/delBorder.vue";
import controlButton from "@/components/controlButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { EquipmentsDelete, CompanyInfoes, EquipmentsAdd } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { downloadExcel } from "@/util/download.js";
import { nextTick } from "@vue/runtime-core";

export default {
  name: "serviceSN",
  components: {
    textField,
    delBorder,
    tabelPanel,
    popDialog,
    updateButton,
    controlButton,
  },
  data() {
    return {
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      centerDialogVisible: false,
      saveBOX: false,
      rowTemplate: [
        {
          columnType: "check",
        },
        {
          headerLabel: "客户名称",
          sortable: true,
          dataIndex: "CompName",
          width: "100",
        },
        {
          headerLabel: "品牌",
          sortable: true,
          dataIndex: "BrandName",
          width: "100",
        },
        {
          headerLabel: "类型",
          sortable: true,
          dataIndex: "ProductName",
        },
        {
          headerLabel: "型号",
          sortable: true,
          dataIndex: "ModelNoStr",
          width: "80",
        },
        {
          headerLabel: "SN号",
          sortable: true,
          dataIndex: "SN",
        },
        {
          headerLabel: "附件",
          dataIndex: "AttachName",
          width: "210",
        },
        {
          headerLabel: "备注",
          dataIndex: "IllDesc",
        },
        {
          headerLabel: "变更日期",
          dataIndex: "MoveDate ",
          // width: "210",
        },
        {
          headerLabel: "操作",
          slot: "oprator",
          width: "80",
        },
      ],
      conditionData: {
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelId: null,
        SN: null,
      },
      BrandData: null,
      ProductData: null,
      modelData: null,
      AttachData: null,
      ModelIllData: null,
      popSaveData: {
        BrandId: null, // BrandId	int	品牌Id  1
        ProductId: null, // ProductId	int	产品Id 1
        CusApp: "", // CusApp	string	系统信息标注
        ModelNoid: null, // ModelNoid	int	型号Id 1
        ModelIllId: null, // ModelIllId	int	症状id 1
        SerialNoName: "", // SerialNoName	string	SN 1
        AttachInfoId: null, // AttachInfoId	Int	附件Id
        IllDesc: "", // IllDesc	string	备注 1
        AttachName: "", //string  附件名称
      },
      CusAppArr: [],
      checkedListS: [],
      checkedList: [],
      checkedListId: [],
      checkedListArr: [],
      selectChildData: null,
      selectChildMoid: null,
      rowsCount: "",
    };
  },

  created() {
    this.companyAdd();
  },
  watch: {
    "conditionData.BrandId"(newV, oldV) {
      this.$refs.selectChild.stringValue = "";
      if (newV) {
        this.selectOuguNameProduct(newV);
        return;
      }
      this.selectChildData = null;
    },
    "conditionData.ProductId"(newV, oldV) {
      this.$refs.selectChildMoid.stringValue = "";
      if (newV) {
        this.selectOuguNameModelSelect(newV);
        return;
      }
      this.selectChildMoid = null;
    },
  },
  mounted() {
    // this.TabelCount()
  },
  methods: {
    getListData(newV) {
      this.rowsCount = newV.data.count;
    },
    // TabelCount(){
    //   tableApi.Equipmentsindex({page:1, limit:20}).then((data) => {
    //     console.log('zxc---',data.data.count)
    //     this.rowsCount = data.data.count
    //   });
    // },
    // 导出
    exportFn() {
      console.log("导出", this.$refs.tabel);
      const selected = this.$refs.tabel.getSelection();
      console.log("导出", selected);
      tableApi.EquipmentsindexList(this.conditionData).then((data) => {
        downloadExcel(data, "设备维护");
      });
    },
    /**
     * @description: 客户数据
     * @param {*}
     * @return {*}
     */
    async selectOuguName() {
      let source = await tableApi.CompanyInfoRole();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动一级数据
     * @param {*}
     * @return {*}
     */
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 二级数据
    async selectOuguNameProduct(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 三级数据
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }

      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 附件下的选择框改变事件
    handleCheckedCitiesChange(value) {
      console.log("value--", value);
      this.checkedListArr.push(value.Name);
      this.checkedListId.push(value.id);
      this.popSaveData.AttachInfoId = this.checkedListId.toString();
      this.popSaveData.AttachName = this.checkedListArr.toString();
      console.log("this.checkedList---", this.checkedList);
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 查看图片
    handOpenImg(row) {
      this.openImg =
        row.ImageUrl || "http://192.168.1.237:8088/img/482.137a0e6e.jpg";
      this.centerDialogVisible = true;
    },
    //删除
    delSingleUser({ row }) {
      let Id = row.Id;
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          EquipmentsDelete({ Id, Pid: row.Pid, SN: row.SN }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    // 保存列表
    listDataSave({ slotData }) {
      let RepairSaveData = this.popSaveData;
      if (RepairSaveData.ModelNoid == "" || RepairSaveData.ModelNoid == null) {
        errMsg("型号不能为空");
        return;
      }
      if (
        RepairSaveData.SerialNoName == "" ||
        RepairSaveData.SerialNoName == null
      ) {
        errMsg("SN号不能为空");
        return;
      }
      // if (RepairSaveData.ModelIllId == "" || RepairSaveData.ModelIllId == null) {
      //     errMsg("症状不能为空");
      //     return;
      // }
      let stingArr = this.checkedList.toString();
      RepairSaveData.AttachInfoId = stingArr;
      RepairSaveData.id = slotData.id;

      if (slotData.id === 0) {
        let paramData = JSON.stringify(RepairSaveData);
        EquipmentsAdd({ data: paramData }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.clearableFrom();
            this.loadShow = false;
            console.log(123);
            this.popSaveData.BrandId = null;
            this.popSaveData.ProductId = null;
            this.popSaveData.ModelNoid = null;
            this.ProductData = null;
            this.modelData = null;
            this.AttachData = null;
          } else {
            errMsg(data.message);
          }
        });
      } else {
        // RepairAdd(RepairSaveData).then((data) => {
        //     if (data.code == 0) {
        //         successMsg(data.message);
        //         this.reloadData();
        //         this.clearableFrom();
        //         this.loadShow = false;
        //     } else {
        //         errMsg(data.message);
        //     }
        // });
      }
    },
    clearableFrom() {
      this.checkedList = [];
      this.checkedListArr = [];
      this.popSaveData.SerialNoName = "";
      this.popSaveData.AttachInfoId = "";
      this.popSaveData.AttachName = "";
    },
    addPower() {
      let id = 0;
      this.loadShow = true;
      this.$nextTick(() => {
        this.$refs.getMenuList.showPopDialog(
          { id },
          "维修设备信息添加",
          "slot"
        );
      });
    },
    companyAdd() {
      CompanyInfoes().then((data) => {
        if (data.code == 0) {
          this.companyData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
      //品牌名称
      tableApi.BrandSelect().then((data) => {
        if (data.code == 0) {
          this.BrandData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    //产品类别
    addProductSelect() {
      let Bid = this.popSaveData.BrandId;
      tableApi.ProductSelect({ Bid }).then((data) => {
        if (data.code == 0) {
          this.ProductData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 型号
    addModelSelect() {
      let ProductCategoryId = this.popSaveData.ProductId;
      tableApi.modelSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.modelData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
      this.addAttachSelect();
    },
    // 附件
    addAttachSelect() {
      let ProductCategoryId = this.popSaveData.ProductId;
      tableApi.AttachSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.AttachData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    //症状
    addModelIllSelect() {
      let ProductCategoryId = this.popSaveData.ProductId;
      tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.ModelIllData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    //症状
    addModelIllID(val) {
      let obj = {};
      obj = this.ModelIllData.find(function (item) {
        return item.id === val;
      });
      this.CusAppArr.push(obj.Name);
      this.popSaveData.CusApp = this.CusAppArr.toString();
    },
    companyValue() {
      this.LinkManID = null;
      this.LinkManData = null;
      this.formInline = {};

      let Company_Id = this.companyID;
      if (Company_Id === null) {
        console.log("选择公司");
      } else {
        linkMan({ Company_Id }).then((data) => {
          if (data.code == 0) {
            this.LinkManData = data.data.list;
          } else {
            errMsg(data.message);
          }
        });
      }
    },
    resetValue(v) {
      console.log("@", v);
      let zxc = this.LinkManData.filter((i) => {
        if (i.id == v) {
          return i;
        }
      });
      console.log("@2", zxc);
      this.formInline = zxc[0];
      // id: 2055, LinkMan: "李智恩"
    },
    //弹层事件
    popConfirmButtonClick() {
      alert(123);
    },
    // 修改
    customerRowDblClick(row) {
      // console.log("row:", row);
    },
    checkedTrue() {
      let AttachIds = this.rowData.AttachId.split(",").map((a) => parseInt(a));
      this.checkedList = AttachIds;
    },
    SNSearch(v) {
      console.log(v);
      tableApi.SearchCusApplyRepairBySNS({ sns: v }).then((data) => {
        if (data.code == 0) {
          let sn = data.data.list;
          console.log("sn@", sn);
          this.popSaveData.BrandId = sn.BrandId;
          this.popSaveData.ProductId = sn.ProCateId;
          this.popSaveData.ModelNoid = sn.ModelNoId;
          this.popSaveData.ModelIllId = null;
          this.popSaveData.CusApp = "";
          this.addProductSelect();
          this.addModelSelect();
        } else {
          errMsg(data.message);
          this.popSaveData.BrandId = null;
          this.popSaveData.ProductId = null;
          this.popSaveData.ModelNoid = null;
          this.AttachData = null;
          // this.addModelSelect()
        }
      });
    },
  },
  activated() {
    // console.log("1激活", this.conditionData);
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .table-panel-containers .condition-containe {
    height: 200px;
  }

  .demo-ruleForm {
    display: flex;
    flex-wrap: wrap;

    .el-form-item,
    .is-required {
      width: 300px;
      margin-bottom: 10px;
      color: #165ff1;

      .itemInput {
        color: red;
      }
    }
  }

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  .oprationTree {
    height: 300px;
    overflow: auto;
  }

  #loadBOX {
    width: 100%;

    .saveBox {
      width: 800px !important;
    }

    .saveBox > div {
      padding: 10px;
      margin: 10px;

      .el-checkbox {
        margin-right: 15px;
      }

      .colorRed {
        color: red;
      }
    }
  }
}

.el-select-dropdown__item {
  text-align: left;
  padding: 0 10px;
}

.el-input {
  width: 100%;
}

.commitCSS {
  margin-left: 15px;
}

.inputSN {
  width: 75%;
}

::v-deep .el-form-item__label {
  color: black;
  font-weight: bold;
  font-size: 18px;
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
